import {
  Box,
  RadioButton,
  RadioButtonGroup,
  Typography,
} from "@bca/ui-library";
import React from "react";
import styled, { css } from "styled-components";

import { NUMBER_OF_DAYS_OPTIONS } from "../APICalls/buildGetPurchasesUrl";
import Filter from "../Interfaces/Filter";

const Container = styled(Box)`
  ${css({
    border: "normalBorder",
    color: "grey-blue",
  })}
`;

interface DateRangeProps {
  selectedFilter: string;
  setSelectedFilter: (event: NUMBER_OF_DAYS_OPTIONS) => void;
  filters: Filter[];
}

const DateRange: React.FunctionComponent<DateRangeProps> = ({
  selectedFilter,
  setSelectedFilter,
  filters,
}) => {
  const onSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFilter(event.target.value as NUMBER_OF_DAYS_OPTIONS);
  };
  return (
    <Container
      as="aside"
      width="100%"
      maxWidth={210}
      height={300}
      mr={5}
      flexDirection="column"
      display="flex"
    >
      <Box marginBottom="15px">
        <Typography variant="h6" m={0}>
          Date Range
        </Typography>
      </Box>
      <RadioButtonGroup
        name="date-range"
        onChange={onSelect}
        orientation="vertical"
        value={selectedFilter}
      >
        {filters?.map((filter: Filter) => (
          <RadioButton
            key={filter.key}
            label={filter.label}
            value={filter.key}
          />
        ))}
      </RadioButtonGroup>
    </Container>
  );
};

export default DateRange;
